import { render, staticRenderFns } from "./SearchPageMobile.vue?vue&type=template&id=0bd44dc2&scoped=true"
import script from "./SearchPageMobile.vue?vue&type=script&lang=js"
export * from "./SearchPageMobile.vue?vue&type=script&lang=js"
import style0 from "./SearchPageMobile.vue?vue&type=style&index=0&id=0bd44dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd44dc2",
  null
  
)

export default component.exports